import { render, staticRenderFns } from "./InvoiceDiscountForm.vue?vue&type=template&id=cbfefefa&"
import script from "./InvoiceDiscountForm.vue?vue&type=script&lang=js&"
export * from "./InvoiceDiscountForm.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDiscountForm.vue?vue&type=style&index=0&id=cbfefefa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports